import moment from "moment";
import _ from 'lodash';
export var getPresentationTypes = function () {
    return [{
            displayName: 'Comparison Line Chart',
            displayOrder: 1,
            name: 'LINE_CHART'
        }, {
            displayName: 'Pie Chart',
            displayOrder: 0,
            name: 'PIE_CHART'
        }, {
            displayName: 'Stacked Area Chart',
            displayOrder: 0,
            name: 'STACKED_AREA_CHART'
        }, {
            displayName: 'Single Table',
            displayOrder: 2,
            name: 'SINGLE_TABLE'
        }, {
            displayName: 'Summary',
            displayOrder: 0,
            name: 'SUMMARY'
        }, {
            displayName: 'Simple Line Chart',
            displayOrder: 3,
            name: 'SIMPLE_LINE_CHART'
        },
        {
            displayName: 'Stacked Bar Chart',
            displayOrder: 0,
            name: 'STACKED_BAR_CHART'
        },
        {
            displayName: '100% Stacked Bar Chart',
            displayOrder: 0,
            name: 'STACKED_BAR_CHART_100'
        }
    ];
};
export var listDefaultMetricFieldsSelected = [
    "date",
    "request",
    "impression",
    "click",
    "ctr",
    "cpm",
    "cpm_per_imp",
    "platform_revenue",
    "platform_revenue",
    "dau_publisher_revenue",
    "mau_publisher_revenue",
    "pv_publisher_revenue",
    "total_revenue",
    "enhance_revenue",
    "dau_total_revenue",
    "mau_total_revenue",
    "pv_total_revenue"
];
export var metricsGA = [
    "session",
    "pv",
    "dau",
    "session_total_revenue",
    "pv_total_revenue",
    "pv_publisher_revenue"
];
export var metricDimensionRequiredByGA = [
    "date",
    "media_name",
    "media_id",
    "publisher_id",
    "publisher_name"
];
export var metricNonDimensionByGA = [
    "sub_platform_group_name",
    "sub_platform_group_id",
    "platform_group_id",
    "platform_group_name",
    "platform_name",
    "platform_id",
    "pubdesk_inventory_id",
    "pubdesk_inventory_name",
    "platform_inventory_name",
    "platform_inventory_id",
];
export var checkDefaultMetricSelected = function (metric) {
    if (metric && metric.defaultCollectionField) {
        var foundMetricDefault = listDefaultMetricFieldsSelected.find(function (defaultMetric) { return defaultMetric == metric.defaultCollectionField; });
        if (foundMetricDefault)
            return true;
        return false;
    }
    return false;
};
export var getCompareRangeDate = function (start, end, label, labelDateRange) {
    var dataDimensionDate = {};
    var dataDimensionNonDate = {};
    switch (label) {
        case 'DAILY':
            return getDailyDate();
        case 'WEEKLY':
            return getWeeklyDate();
        case 'MONTHLY':
            return getMonthlyDate();
        default:
            return getDailyDate();
    }
    function getCompareNonDate() {
        switch (labelDateRange) {
            case 'Today':
            case 'Yesterday':
                dataDimensionNonDate = {
                    start: moment(start, 'YYYY-MM-DD').subtract(1, 'days').format('YYYY-MM-DD'),
                    end: moment(end, 'YYYY-MM-DD').subtract(1, 'days').format('YYYY-MM-DD')
                };
                break;
            case 'This Week':
            case 'Last Week':
                dataDimensionNonDate = {
                    start: moment(start, 'YYYY-MM-DD').subtract(1, 'weeks').format('YYYY-MM-DD'),
                    end: moment(end, 'YYYY-MM-DD').subtract(1, 'weeks').format('YYYY-MM-DD')
                };
                break;
            case 'Last 7 Days':
                dataDimensionNonDate = {
                    start: moment(start, 'YYYY-MM-DD').subtract(7, 'days').format('YYYY-MM-DD'),
                    end: moment(end, 'YYYY-MM-DD').subtract(7, 'days').format('YYYY-MM-DD')
                };
                break;
            case 'Last 30 Days':
                dataDimensionNonDate = {
                    start: moment(start, 'YYYY-MM-DD').subtract(30, 'days').format('YYYY-MM-DD'),
                    end: moment(end, 'YYYY-MM-DD').subtract(30, 'days').format('YYYY-MM-DD')
                };
                break;
            case 'This Month':
            case 'Last Month':
                dataDimensionNonDate = {
                    start: moment(start, 'YYYY-MM-DD').subtract(1, 'months').format('YYYY-MM-DD'),
                    end: moment(end, 'YYYY-MM-DD').subtract(1, 'months').endOf('months').format('YYYY-MM-DD')
                };
                break;
            case 'Last 3 Months':
                dataDimensionNonDate = {
                    start: moment(start, 'YYYY-MM-DD').subtract(3, 'months').format('YYYY-MM-DD'),
                    end: moment(end, 'YYYY-MM-DD').subtract(3, 'months').endOf('months').format('YYYY-MM-DD')
                };
                break;
            case 'This Year':
                dataDimensionNonDate = {
                    start: moment(start, 'YYYY-MM-DD').subtract(1, 'years').format('YYYY-MM-DD'),
                    end: moment(end, 'YYYY-MM-DD').subtract(1, 'years').format('YYYY-MM-DD')
                };
                break;
            case 'Custom Range':
                var numberOfDate = moment(end, 'YYYY-MM-DD').diff(moment(start, 'YYYY-MM-DD'), 'days') + 1;
                dataDimensionNonDate = {
                    start: moment(start, 'YYYY-MM-DD').subtract(numberOfDate, 'days').format('YYYY-MM-DD'),
                    end: moment(end, 'YYYY-MM-DD').subtract(numberOfDate, 'days').format('YYYY-MM-DD')
                };
                break;
            default:
                var numberOfDate = moment(end, 'YYYY-MM-DD').diff(moment(start, 'YYYY-MM-DD'), 'days') + 1;
                dataDimensionNonDate = {
                    start: moment(start, 'YYYY-MM-DD').subtract(numberOfDate, 'days').format('YYYY-MM-DD'),
                    end: moment(end, 'YYYY-MM-DD').subtract(numberOfDate, 'days').format('YYYY-MM-DD')
                };
                break;
        }
    }
    function getDailyDate() {
        dataDimensionDate = {
            start: moment(start, 'YYYY-MM-DD').subtract(1, 'days').format('YYYY-MM-DD'),
            end: moment(end, 'YYYY-MM-DD').subtract(1, 'days').format('YYYY-MM-DD'),
        };
        getCompareNonDate();
        return {
            date: _.clone(dataDimensionDate),
            nonDate: _.clone(dataDimensionNonDate),
            label: label
        };
    }
    function getWeeklyDate() {
        dataDimensionDate = {
            start: moment(start, 'YYYY-MM-DD').subtract(1, 'weeks').format('YYYY-MM-DD'),
            end: moment(end, 'YYYY-MM-DD').subtract(1, 'weeks').format('YYYY-MM-DD'),
        };
        getCompareNonDate();
        return {
            date: _.clone(dataDimensionDate),
            nonDate: _.clone(dataDimensionNonDate),
            label: label
        };
    }
    function getMonthlyDate() {
        dataDimensionDate = {
            start: moment(start, 'YYYY-MM-DD').subtract(1, 'months').format('YYYY-MM-DD'),
            end: moment(end, 'YYYY-MM-DD').subtract(1, 'months').format('YYYY-MM-DD'),
        };
        getCompareNonDate();
        return {
            date: _.clone(dataDimensionDate),
            nonDate: _.clone(dataDimensionNonDate),
            label: label
        };
    }
};
export var reportLevelOptions = [
    {
        value: "DAILY",
        label: "daily"
    },
    {
        value: "WEEKLY",
        label: "weekly"
    },
    {
        value: "MONTHLY",
        label: "monthly"
    }
];
export var scheduleReportExportOptions = [
    {
        value: "EXCEL",
        label: "Excel"
    },
    {
        value: "CSV",
        label: "CSV"
    }
];
export var reportHourOptions = [
    {
        value: 0,
        label: "00:00"
    },
    {
        value: 1,
        label: "01:00"
    },
    {
        value: 2,
        label: "02:00"
    },
    {
        value: 3,
        label: "03:00"
    },
    {
        value: 4,
        label: "04:00"
    },
    {
        value: 5,
        label: "05:00"
    },
    {
        value: 6,
        label: "06:00"
    },
    {
        value: 7,
        label: "07:00"
    },
    {
        value: 8,
        label: "08:00"
    },
    {
        value: 9,
        label: "09:00"
    },
    {
        value: 10,
        label: "10:00"
    },
    {
        value: 11,
        label: "11:00"
    },
    {
        value: 12,
        label: "12:00"
    },
    {
        value: 13,
        label: "13:00"
    },
    {
        value: 14,
        label: "14:00"
    },
    {
        value: 15,
        label: "15:00"
    },
    {
        value: 16,
        label: "16:00"
    },
    {
        value: 17,
        label: "17:00"
    },
    {
        value: 18,
        label: "18:00"
    },
    {
        value: 19,
        label: "19:00"
    },
    {
        value: 20,
        label: "20:00"
    },
    {
        value: 21,
        label: "21:00"
    },
    {
        value: 22,
        label: "22:00"
    },
    {
        value: 23,
        label: "23:00"
    }
];
export var reportDayOfWeekOptions = [
    {
        value: 1,
        label: "Mon"
    },
    {
        value: 2,
        label: "Tue"
    },
    {
        value: 3,
        label: "Wed"
    },
    {
        value: 4,
        label: "Thu"
    },
    {
        value: 5,
        label: "Fri"
    },
    {
        value: 6,
        label: "Sat"
    },
    {
        value: 7,
        label: "Sun"
    }
];
export var reportDayOfMonthOptions = [
    {
        value: 1,
        label: "1"
    },
    {
        value: 2,
        label: "2"
    },
    {
        value: 3,
        label: "3"
    },
    {
        value: 4,
        label: "4"
    },
    {
        value: 5,
        label: "5"
    },
    {
        value: 6,
        label: "6"
    },
    // 7 to 30
    {
        value: 7,
        label: "7"
    },
    {
        value: 8,
        label: "8"
    },
    {
        value: 9,
        label: "9"
    },
    {
        value: 10,
        label: "10"
    },
    {
        value: 11,
        label: "11"
    },
    {
        value: 12,
        label: "12"
    },
    {
        value: 13,
        label: "13"
    },
    {
        value: 14,
        label: "14"
    },
    {
        value: 15,
        label: "15"
    },
    {
        value: 16,
        label: "16"
    },
    {
        value: 17,
        label: "17"
    },
    {
        value: 18,
        label: "18"
    },
    {
        value: 19,
        label: "19"
    },
    {
        value: 20,
        label: "20"
    },
    {
        value: 21,
        label: "21"
    },
    {
        value: 22,
        label: "22"
    },
    {
        value: 23,
        label: "23"
    },
    {
        value: 24,
        label: "24"
    },
    {
        value: 25,
        label: "25"
    },
    {
        value: 26,
        label: "26"
    },
    {
        value: 27,
        label: "27"
    },
    {
        value: 28,
        label: "28"
    },
    {
        value: 29,
        label: "29"
    },
    {
        value: 30,
        label: "30"
    },
    {
        value: 31,
        label: "31"
    },
    {
        value: 32,
        label: "月末"
    }
];
export var reportWeekOfMonthOptions = [
    {
        value: 1,
        label: "1st"
    },
    {
        value: 2,
        label: "2nd"
    },
    {
        value: 3,
        label: "3rd"
    },
    {
        value: 4,
        label: "4th"
    }
];
